/** Rutas relativas al prefijo `/reservas`. */
export const reservationsPaths = {
  new: 'nueva',
  detail: ':id',
  edit: 'editar',
} as const;
